export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '425495a', dateTime: 1765989952426 };